// @flow

import type {Effect} from '../../types'

import {
  take,
  call,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'
import {showMap} from '../../map/lib/showMap'
import {ensureMapReady} from './ensureMapReady'
import {ensureCurrentLocation} from './ensureCurrentLocation'
import {createUserData} from '../../../api/createUserData'

export function* enterMapEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'home') {
      yield call(ensureMapReady)
      yield call(showMap)
      yield call(ensureCurrentLocation)
      // yield call(createUserData)
    }
  }
}
